import React from "react";
import Svg, { G, Path, Ellipse, Circle } from "react-native-svg";

const CheckIcon = ({ width, height, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 21 15"
      preserveAspectRatio="xMidYMin meet"
    >
      <G id="Flow-Redesign" stroke="none" strokeWidth="1" fill="none">
        <G
          id="redesign-2"
          transform="translate(-59.000000, -379.000000)"
          fill={color}
          fillRule="nonzero"
        >
          <G id="checked" transform="translate(59.000000, 379.000000)">
            <Path
              d="M7.55520907,14.5384615 C7.12912468,14.5384615 6.70259733,14.3820943 6.37755848,14.069123 L0.48792741,8.40244354 C-0.16264247,7.77650094 -0.16264247,6.76181854 0.48792741,6.13587594 C1.13849729,5.50993334 2.19310168,5.50993334 2.84367156,6.13587594 L7.55520907,10.6690585 L18.1563777,0.469385917 C18.8069475,-0.156367258 19.861798,-0.156556679 20.5119249,0.469385917 C21.1626917,1.09532851 21.1626917,2.11024769 20.5119249,2.73595351 L8.73310576,14.069123 C8.40782082,14.3819049 7.98149034,14.5384615 7.55520907,14.5384615 Z"
              id="Path"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

CheckIcon.defaultProps = {
  width: 23,
  height: 17,
  color: "#FFC41F",
};

export default CheckIcon;
